import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { VhIconComponent } from '../icon/icon.component';

export type VhResultView = 'grid' | 'list';

/**
 * Grid / list view toggle. Segmented control pattern.
 */
@Component({
  selector: 'vh-view-toggle',
  standalone: true,
  imports: [VhIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="vh-view-toggle" role="group" [attr.aria-label]="ariaLabel()">
      <button
        type="button"
        class="vh-view-toggle__btn"
        [class.vh-view-toggle__btn--active]="value() === 'grid'"
        [attr.aria-pressed]="value() === 'grid'"
        (click)="select('grid')"
      >
        <vh-icon name="grid" size="sm" />
        <span class="vh-view-toggle__label">Grid</span>
      </button>
      <button
        type="button"
        class="vh-view-toggle__btn"
        [class.vh-view-toggle__btn--active]="value() === 'list'"
        [attr.aria-pressed]="value() === 'list'"
        (click)="select('list')"
      >
        <vh-icon name="list" size="sm" />
        <span class="vh-view-toggle__label">List</span>
      </button>
    </div>
  `,
  styleUrl: './view-toggle.component.scss',
})
export class VhViewToggleComponent {
  readonly value = input<VhResultView>('grid');
  readonly ariaLabel = input<string>('View layout');

  readonly viewChange = output<VhResultView>();

  select(view: VhResultView): void {
    if (view === this.value()) return;
    this.viewChange.emit(view);
  }
}
